<template>
    <span>   
        <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-width="200"
            offset-y
            transition="scale-transition"
            :max-width="$vuetify.breakpoint.name == 'xs' ? '360' : 'auto'"
        >
            <template v-slot:activator="{ on, attrs }">
                <img 
                    :src="`${require('@/assets/icono-bag.png')}`" 
                    class='bag-shop' 
                    v-bind="attrs"
                    v-on="on"
                >
                <v-badge 
                    bottom 
                    overlap 
                    color="primary"
                    bordered 
                    offset-x="40" 
                    offset-y="9"
                >
                    <template v-slot:badge>
                        {{totalQuantity}}
                    </template>
                </v-badge>
            </template>
            <v-card>
                <v-list v-if="shoppingCar.length">
                    <v-alert
                        dense
                        color="primary"
                        class='mx-4 font-title font-weight-bold font-italic white--text'
                    >
                        <v-icon class='white--text'>mdi-check-circle-outline</v-icon> El producto seleccionado se agregó a su bolsa de compra
                        <div class='caption'>({{shoppingCar.length}} productos en total)</div>
                    </v-alert>
                    <v-list-item 
                        v-for="(sc, x) in shoppingCar" 
                        :key=x 
                        dense 
                        two-line
                    >
                        <v-list-item-icon style="margin: 25px 3px 0 0">
                            <v-icon
                                color="red"
                                @click='deleteItem(sc)'
                            >mdi-close</v-icon>
                        </v-list-item-icon>
                        <v-list-item-avatar size=80 class='py-0 my-0'>
                            <img 
                                :src="`${!!sc.images ? (urlApi+pathFileProducts+sc.images) : ''}`" 
                                style="height: 40px"
                            >
                        </v-list-item-avatar>
                        <v-list-item-title>
                            <div class="text-capitalize font-text-h5 ml-1" style="white-space: break-spaces;"> 
                                <b v-html=sc.internal_name></b>
                            </div>
                            Cantidad: X {{sc.quantity}}
                        </v-list-item-title> 
                        <v-list-item-icon :style="$vuetify.breakpoint.name == 'xs' ? 'margin: 23px 0 0 0;width:56%' : 'margin: 23px  0 0 0;width:32%'">
                            <div style='border:2px solid #50c995' class="rounded-xl text-caption">
                                <v-icon class="primary--text px-2" @click="quantity('-',sc.product_id)">mdi-minus mdi-18px</v-icon> 
                                <span class='font-weight-bold gray--text'>{{sc.quantity}}</span>
                                <v-icon class="primary--text px-2" @click="quantity('+',sc.product_id)">mdi-plus mdi-18px</v-icon>
                            </div>
                        </v-list-item-icon>
                    </v-list-item>
                    <div class='text-center'>
                        <v-btn
                            rounded
                            @click="menu = false"
                            color="blue white--text"
                            class='px-8 font-title font-weight-bold font-italic text-capitalize mx-2 mb-2 mb-sm-0'
                        >
                            Agregar más productos
                        </v-btn>
                        <v-btn
                            color="blue white--text"
                            rounded
                            class="px-8 font-title font-weight-bold font-italic text-capitalize mx-2 mt-2 mt-sm-0"
                            @click=closeDrawer
                        >
                            Completar compra
                        </v-btn>
                    </div>
                </v-list>
                <v-list v-else>
                    <v-list-item>
                        <v-list-item-title>
                            <v-icon class='primary--text'>mdi-alert-circle</v-icon> Sin productos agregados
                        </v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-card>
        </v-menu>
        <span v-if="loggedIn">
            <v-tooltip bottom >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn 
                        outlined 
                        rounded 
                        icon  
                        class="btn-logout"
                        v-bind="attrs"
                        v-on="on" 
                        @click="logoutCliente"
                    >
                        <v-icon >mdi-logout</v-icon>
                    </v-btn>
                </template>
                <span>Cerrar sesión</span>
            </v-tooltip>
        </span>
        <span v-else>
        <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
                <v-btn 
                    outlined 
                    rounded 
                    icon  
                    class="btn-logout"
                    v-bind="attrs"
                    v-on="on" 
                    @click="checkLogin"
                >
                    <v-icon >mdi-account-outline</v-icon>
                </v-btn>

            </template>
            <span>Iniciar sesión</span>
        </v-tooltip>
        </span>
        <div v-if="loggedIn" class="white--text" style="position:absolute"><b>Hola {{this.user.name}}</b></div>
        <LoginWebComponent 
            :dialogLogin=dialogLogin 
            @close="dialogLogin=false" 
            :text=textLogin
        />
    </span>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import LoginWebComponent from '../partials/LoginWebComponent'

export default {
    name:'MiniShippingCarComponent',
    components:{
        LoginWebComponent
    },
    data:()=>({
        menu:false,
        dialogLogin:false,
        textLogin:undefined,
        selectProduct:{}
    }),
    computed:{

        ...mapState(['shoppingCar','totalQuantity','urlApi','pathFileProducts','loggedIn','user','userVerificated'])

    },
    methods: {

        ...mapMutations(['itemShoppingCar','setTotalQuantity','setCheckout','setUrl','setActionsRol','setActionsRol','setLogedIn','setUserVerificated']),

        ...mapActions(['logoutAction','requestApi','alertNotification']),

        deleteItem(product){

            let products = this.shoppingCar
            let obj = products.find(e => e.product_id == product.product_id)
            if(typeof obj != 'undefined'){
                let index = products.indexOf(obj)
                products.splice(index,1)
                this.itemShoppingCar(products)
            }
            
        },

        closeDrawer(){

            if(this.loggedIn){

                this.$router.push('/medicamentos-especialidad/cotizacion')
                this.$emit('closeDrawer',true)
                this.textLogin= undefined
                this.menu= false
                
            }else{

                this.dialogLogin= true
                this.textLogin= 'ACCEDE CON TU USUARIO Y CONTRASEÑA PARA CONTINUAR CON EL PROCESO'

            }

        },

        quantity(operator,product_id){
            
            let products= this.shoppingCar
            let itemExist = products.find(e => e.product_id == product_id)

            if(typeof itemExist !='undefined'){

                let index = products.indexOf(itemExist)
                
                if(operator == '+'){
                    products[index].quantity+=1
                }else{
                    if(products[index].quantity){
                        products[index].quantity-=1
                    }
                }
               
            }

            this.itemShoppingCar(products)
         
        },

        logoutCliente(){

            this.setUrl('user-laboratorio')
            
            this.requestApi({
                method:'DELETE',
                data:{
                    access_token: this.token,
                    userLoginId : this.user.user_ligin_id,
                    system: 'web-page',
                    dataBase: 'obfinnofarm',
                    comment: 'ha cerrado sesión en la página web de innofarm'
                }
            }).then(res =>{

                localStorage.removeItem('token')
                localStorage.setItem('user','')
                this.setLogedIn(false)
                this.setActionsRol()
                this.setUserVerificated(false)
                this.alertNotification({
                    param: {
                        html: 'Hasta pronto ' + this.user.user_ligin_id.toUpperCase()
                    }
                })


            }).catch(err =>{
                
                let response = err.response;
                this.errorRequest({
                    data : {
                        datos: response.data.errors,
                        status : response.status,
                    }
                });
                this.overlay=false

            });

        },

        checkLogin(){

            if(!this.loggedIn)
                this.textLogin = undefined

            this.dialogLogin = true
            
        }

    },
    created(){
        
        if(localStorage.getItem('shoppingCar') !='null'){
            let products = JSON.parse(localStorage.getItem('shoppingCar'))
            this.itemShoppingCar(products)
        }
    
    },
    mounted(){
        console.log(this.userVerificated)
        if(this.userVerificated && !this.loggedIn)
            this.dialogLogin = true
    }
}
</script>

<style>

    .bag-shop{
        width:50px;
        position:relative;
        left: 7px;
        top: 12px;
    }

    .btn-logout{
        position: relative;
        bottom: 7px;
        border: 3px solid;
        margin-left: 10px;
        color: #f9fbfa!important;
        height: 41px!important;
        width: 41px!important;
    }

   .mdi-close::before {
        font-weight: 900;
    }

    .v-avatar {
        border-radius: 0%!important
    }

    @media (max-width: 1122px){
		.bag-shop{
            width:40px;
        }
	}

     @media (max-width: 959px){
		.bag-shop{
            width:60px;
        }
	}

</style>